import React, {useRef} from "react";

// shared page components
import StartFree from "../shared/StartFree.jsx";

// core components
import DefaultNavbar from "components/Navbars/DefaultNavbar.jsx";
import DefaultFooter from "components/Footers/DefaultFooter.jsx";

import Contact from "../shared/Contact";
import ChildPageContainer from "../shared/ChildPageContainer";
import ChildPageHeading from "../alter3/ChildPageHeading";
import Pricing from "../shared/Pricing";
import Faqs from "../shared/Faqs";

const PricingPage = () => {
   const mainRef = useRef();
     return (
      <>
        <DefaultNavbar />
        <main ref={mainRef}>
           <ChildPageHeading/>
           <ChildPageContainer>
              <>
                 <Pricing extended={true}/>
              </>
           </ChildPageContainer>
           <Faqs/>
          <StartFree />
          <Contact />
          {/*<Subscribe/>*/}
        </main>
        <DefaultFooter />
      </>
    );
}

export default PricingPage;
